/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
import { Controller } from "stimulus";
import { calculateDifference } from "./difference.js";

export default class Countdown extends Controller {
	currentIndex = 0;
	interval_id: number;

	declare dateValue: string;

	static values = {
		date: String,
	};

	static targets = ["day", "hour", "minute", "second", "ticker"];
	declare dayTarget: HTMLDivElement;
	declare hourTarget: HTMLDivElement;
	declare minuteTarget: HTMLDivElement;
	declare secondTarget: HTMLDivElement;
	declare tickerTarget: HTMLDivElement;

	async connect() {
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		this.interval_id = setInterval(() => this.tick(), 1000) as unknown as number;
		this.tickerTarget.style.setProperty("animation", "none"); // we're gonna animate it ourselves to keep it in sync with the js-changed seconds countdown
	}

	async disconnect() {
		clearInterval(this.interval_id);
	}

	tick() {
		const { days, hours, minutes, seconds } = calculateDifference(this.dateValue);
		this.dayTarget.textContent = days.toString();
		this.hourTarget.textContent = hours.toString();
		this.minuteTarget.textContent = minutes.toString().padStart(2, "0");
		this.secondTarget.textContent = seconds.toString().padStart(2, "0");
		this.tickerTarget.style.setProperty("opacity", seconds % 2 ? "0" : "1");
	}
}
